import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Image, StyleSheet, Text, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import Colors from '../../constants/Colors';
import Languages from '../../constants/Languages';
import Layout from '../../constants/Layout';
import * as Actions from '../../store/Actions';
import Header from '../../components/register/Header';
import FilledButton from '../../components/FilledButton';
import MyScrollView from '../../components/MyScrollView';
import PtfKeyboardAvoidingView from '../../components/PtfKeyboardAvoidingView';

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.mediumBlue,
  },
  mainContentContainer: {
    alignItems: 'center',
    backgroundColor: Colors.white,
  },
  topContainer: {
    alignItems: 'center',
  },
  headingText: {
    fontSize: Layout.isSmall ? 20 : 26,
    fontWeight: '500',
    color: Colors.veryDarkGray,
    fontFamily: 'roboto-regular',
    textAlign: 'center',
    marginTop: Layout.isSmall ? 53 : 34,
  },
  text: {
    fontFamily: 'roboto-regular',
    fontSize: Layout.isSmall ? 14 : 16,
    color: Colors.veryDarkGray,
    textAlign: 'center',
    marginTop: 8,
    width: 328,
  },
  image: {
    height: 94,
    width: 129,
    resizeMode: 'contain',
    marginTop: Layout.isSmall ? 33 : 79,
  },
  signupContainer: Layout.signupContainer,
  signupFooter: Layout.signupFooter,
});

class VerificationEmailSentScreen extends Component {
  static propTypes = {
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    navigation: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  constructor(props) {
    super(props);
  }

  goBack = () => {
    const { navigation } = this.props;
    navigation.navigate('Language');
  };

  goNext = () => {
    const { navigation, registration } = this.props;
    const { flow } = registration;
    if (flow === 'existing_email') {
      navigation.navigate('EnterPassword');
    } else {
      navigation.navigate('CreatePassword');
    }
  };

  render() {
    const { registration } = this.props;
    const { language } = registration;
    const translation = Languages.translations[language?.name || 'en'];

    return (
      <SafeAreaView style={{ flex: 1 }} edges={['top', 'left', 'right', 'bottom']}>
        <PtfKeyboardAvoidingView style={{ flex: 1 }}>
          <MyScrollView
            contentContainerStyle={styles.mainContentContainer}
            containerStyle={styles.container}
            testID="verification-email-sent"
          >
            <Header title={translation.sign_up} goBack={this.goBack} />
            <View style={styles.signupContainer}>
              <View style={styles.topContainer}>
                <Image
                  source={require('../../assets/images/sign_up/image_42.png')}
                  resizeMode="cover"
                  style={styles.image}
                />
                <Text style={styles.headingText}>{translation.verification_email_sent}</Text>
                <Text style={styles.text}>{translation.check_verification_email}</Text>
              </View>
              <View style={styles.signupFooter}>
                <FilledButton
                  onPress={this.goNext}
                  label={translation.continue}
                  color={Colors.primaryColor}
                  full
                  textColor={Colors.white}
                />
              </View>
            </View>
          </MyScrollView>
        </PtfKeyboardAvoidingView>
      </SafeAreaView>
    );
  }
}

function mapStateToProps(state) {
  return {
    registration: state.registration,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(VerificationEmailSentScreen);
